/**
 * @generated SignedSource<<10b320071754ab5a4873d232f4941d0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateEventButton_guild$data = {
  readonly slugId: string;
  readonly viewerCanCreateEvents: boolean | null | undefined;
  readonly " $fragmentType": "CreateEventButton_guild";
};
export type CreateEventButton_guild$key = {
  readonly " $data"?: CreateEventButton_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateEventButton_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateEventButton_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanCreateEvents",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "eb0625dd70bb20f1a5189a197711ebb6";

export default node;
